import { useState } from "react";
import { Users, Search, CheckCircle2, XCircle } from "lucide-react";
import { CUSTOMERS, formatTRY, formatInt } from "../data/mock";

export default function Kullanicilar() {
  const [q, setQ] = useState("");
  const list = CUSTOMERS.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()) || c.id.toLowerCase().includes(q.toLowerCase()) || c.bayiId.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-5" data-testid="page-kullanicilar">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <Users className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Kullanıcılar</h1>
          <p className="text-xs text-slate-500">{CUSTOMERS.length} kayıtlı kullanıcı</p>
        </div>
      </div>

      <div className="relative max-w-xs">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Kullanıcı / bayi ara" data-testid="search-user" className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-[#151824] pl-9 pr-4 py-2.5 text-sm" />
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[13px] font-bold text-violet-600 dark:text-violet-400 border-b border-slate-100 dark:border-slate-800">
                <th className="px-6 py-3">KULLANICI ID</th>
                <th className="px-4 py-3">AD SOYAD</th>
                <th className="px-4 py-3">BAYİ</th>
                <th className="px-4 py-3 text-right">BAKİYE</th>
                <th className="px-4 py-3 text-right">İŞLEM</th>
                <th className="px-4 py-3">KAYIT</th>
                <th className="px-6 py-3">DURUM</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {list.map((c) => (
                <tr key={c.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50" data-testid="user-row">
                  <td className="px-6 py-3 font-bold text-slate-700 dark:text-slate-200">{c.id}</td>
                  <td className="px-4 py-3">{c.name}</td>
                  <td className="px-4 py-3 text-slate-500 font-semibold">{c.bayiId}</td>
                  <td className="px-4 py-3 text-right font-bold text-green-600">{formatTRY(c.bakiye)}</td>
                  <td className="px-4 py-3 text-right">{formatInt(c.islem)}</td>
                  <td className="px-4 py-3 text-slate-500">{c.kayit}</td>
                  <td className="px-6 py-3">
                    {c.durum === "Aktif" ? (
                      <span className="inline-flex items-center gap-1 text-green-600 font-semibold text-xs"><CheckCircle2 size={14} /> Aktif</span>
                    ) : (
                      <span className="inline-flex items-center gap-1 text-slate-400 font-semibold text-xs"><XCircle size={14} /> Pasif</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
